import { post } from './common';

export function add(pageId: string) {
  return post(`projects/${pageId}/censures`, { projectId: pageId });
}
